import Api from 'api';
import uuid from 'uuid';
import {
  GET_EMPLOYEES,
  SET_EMPLOYEES_PAGINATION,
  SET_EMPLOYEES_FILTERS,
  RESET_EMPLOYEES,
  TOGGLE_EMPLOYEE,
  ADD_EMPLOYEE,
  UPDATE_EMPLOYEE,
  GET_EMPLOYEE_BY_ID,
  RESET_EMPLOYEE_FORM,
  MODIFY_EDITING_EMPLOYEE,
  MODIFY_CUSTOM_FIELD_EDITING_EMPLOYEE,
  GET_CUSTOM_FIELDS_EMPLOYEES,
  EMPLOYEES_SET_FILE,
  EMPLOYEE_UPLOAD_FILE,
  EMPLOYEE_PROGRESS_FILE,
  GET_EMPLOYEE_REPORT_CSV,
} from 'employees/constants';

export const setFile = (file) => ({
  type: EMPLOYEES_SET_FILE,
  payload: {
    id: uuid.v4(),
    file: file,
    status: 'files.pending',
    percentage: 0,
    preview: file.preview,
    name: file.name,
  },
});

export const uploadFile = (file, companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: EMPLOYEE_UPLOAD_FILE,
    payload: Api.uploads.upload(
      file.file,
      (percentage) => dispatch(progressFile(percentage)),
      companyId,
      subcompanyId
    ),
  });

export const progressFile = (percentage) => ({
  type: EMPLOYEE_PROGRESS_FILE,
  payload: percentage,
});

export const setPagination = (payload) => ({
  type: SET_EMPLOYEES_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_EMPLOYEES_FILTERS,
  payload,
});

export const getEmployees = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_EMPLOYEES,
  payload: Api.employees.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_EMPLOYEES });

export const toggle = (employeeId, companyId, subcompanyId) => ({
  type: TOGGLE_EMPLOYEE,
  meta: { id: employeeId },
  payload: Api.employees.toggle(employeeId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_EMPLOYEE_FORM });

export const getEmployeeById = (employeeId, companyId, subcompanyId) => ({
  type: GET_EMPLOYEE_BY_ID,
  meta: { needAuth: true },
  payload: Api.employees.getById(employeeId, companyId, subcompanyId),
});

export const modifyEmployee = (payload) => ({ type: MODIFY_EDITING_EMPLOYEE, payload });

export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_EMPLOYEE,
  payload,
}); // Agregado

export const addEmployee = (companyId, subcompanyId, employee) => ({
  type: ADD_EMPLOYEE,
  payload: Api.employees.add(companyId, subcompanyId, employee),
});

export const updateEmployee = (employeeId, companyId, subcompanyId, employee) => ({
  type: UPDATE_EMPLOYEE,
  meta: { id: employeeId, needAuth: true },
  payload: Api.employees.update(employeeId, companyId, subcompanyId, employee),
});

export const getEmployeesReportCSV = (companyId, subcompanyId, filters) => ({
  type: GET_EMPLOYEE_REPORT_CSV,
  meta: { needAuth: true },
  payload: Api.employees.getEmployeesReportCSV(companyId, subcompanyId, filters),
});

export const getCustomFieldsEmployees = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_CUSTOM_FIELDS_EMPLOYEES,
  payload: Api.custom_fields_employees.get(
    companyId,
    subcompanyId,
    filters,
    10000,
    1,
    orderBy,
    order
  ),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/actions/employees_actions.js